import { render } from "./whyJoinDialog.vue?vue&type=template&id=e1175fd8"
import script from "./whyJoinDialog.vue?vue&type=script&lang=js"
export * from "./whyJoinDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__